import { pickConfig } from './runtimeConfig';

/** Hosts that should use *staging* URLs (Keycloak, API, download). */
const useStagingEndpoints = (): boolean =>
    /review|local|stage|\.stg\./.test(window.location.hostname);

const DEFAULT_API_STAGING = 'https://ng-outgest-edge-mam-deadpool-staging.boom.sport1.it/api/v1';
const DEFAULT_API_PRODUCTION = 'https://ng-outgest-edge-mam-deadpool.badaboom.sport1.it/api/v1';
const DEFAULT_DOWNLOAD_STAGING = 'https://stage-reshape.sport1.de';
const DEFAULT_DOWNLOAD_PRODUCTION = 'https://reshape.sport1.de';
const DEFAULT_KEYCLOAK_STAGING = 'https://keycloak-stage.sport1dev.de/auth';
const DEFAULT_KEYCLOAK_PRODUCTION = 'https://keycloak.sport1dev.de/auth';
const DEFAULT_KEYCLOAK_REALM = 'Azure';
const DEFAULT_KEYCLOAK_CLIENT_ID = 'account';

export const API_URL = () =>
    useStagingEndpoints()
        ? pickConfig('REACT_APP_API_URI_STAGING', DEFAULT_API_STAGING, 'REACT_APP_API_URI_STAGING')
        : pickConfig('REACT_APP_API_URI_PRODUCTION', DEFAULT_API_PRODUCTION, 'REACT_APP_API_URI_PRODUCTION');

export const DOWNLOAD_URL = () =>
    useStagingEndpoints()
        ? pickConfig('REACT_APP_DOWNLOAD_URL_STAGING', DEFAULT_DOWNLOAD_STAGING, 'REACT_APP_DOWNLOAD_URL_STAGING')
        : pickConfig('REACT_APP_DOWNLOAD_URL_PRODUCTION', DEFAULT_DOWNLOAD_PRODUCTION, 'REACT_APP_DOWNLOAD_URL_PRODUCTION');

export const KEYCLOAK_URL = () =>
    useStagingEndpoints()
        ? pickConfig('REACT_APP_KEYCLOAK_URL_STAGING', DEFAULT_KEYCLOAK_STAGING, 'REACT_APP_KEYCLOAK_URL_STAGING')
        : pickConfig('REACT_APP_KEYCLOAK_URL_PRODUCTION', DEFAULT_KEYCLOAK_PRODUCTION, 'REACT_APP_KEYCLOAK_URL_PRODUCTION');

export const KEYCLOAK_REALM = () => pickConfig('KEYCLOAK_REALM', DEFAULT_KEYCLOAK_REALM);

export const KEYCLOAK_CLIENT_ID = () => pickConfig('KEYCLOAK_CLIENT_ID', DEFAULT_KEYCLOAK_CLIENT_ID);

export const DELAY = 1000;
export const AUTOSAVE_DELAY = 1000;

export const ROLES = {
    admin: { id: 0, name: 'admin' },
    moderator: { id: 1, name: 'moderator' },
    standard: { id: 2, name: 'standard' },
    assetRW: { id: 3, name: 'assetRW' },
    assetRO: { id: 4, name: 'assetRO' },
    ottRW: { id: 5, name: 'ottRW' },
    ottRO: { id: 6, name: 'ottRO' },
    videoAdmin: { id: 7, name: 'videoadmin' },
    videoStandard: { id: 8, name: 'videoStandard' },
    videoEditor: { id: 9, name: 'videoEditor' },
    superEditor: { id: 10, name: 'superEditor'}
};

export const ROLES_BY_ID: Record<string, {id: number, key: string, name: string} | undefined> = Object.entries(ROLES)
    .map(([key, value]) => {
        return {key, ...value};
    })
    .reduce((acc, curr) => {
        acc[curr.id] = curr;
        return acc;
    }, {});

export const GETTY_ACTIVE = false;
